<script setup lang="ts">
  import NoDocumentsIcon from '@/shared/assets/images/no-documents.svg';
  import { IconImage } from '@/shared/ui';
  import {
    DIRECTORIES_EMPTY_SUBTITLE,
    DIRECTORIES_EMPTY_TITLE,
  } from '../config/messages';
</script>

<template>
  <div
    data-testid="directories-empty-state"
    class="flex flex-col items-center justify-center px-4 py-8"
  >
    <IconImage
      :src="NoDocumentsIcon"
      :alt="DIRECTORIES_EMPTY_TITLE"
    />
    <h3 class="mt-6 max-w-[404px] break-words text-center text-xl font-semibold leading-[30px]">
      {{ DIRECTORIES_EMPTY_TITLE }}
    </h3>
    <p class="mt-2 max-w-[404px] text-center text-sm text-gray-05">
      {{ DIRECTORIES_EMPTY_SUBTITLE }}
    </p>
  </div>
</template>
